/**
 * Axios instance for Super-Admin API calls.
 * Использует httpOnly cookies для аутентификации.
 */
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || '/api/v1';

/** Читаем csrf_token из не-httpOnly cookie */
function getCsrfToken(): string | null {
  return document.cookie.match(/csrf_token=([^;]+)/)?.[1] ?? null;
}

const CSRF_METHODS = ['post', 'put', 'delete', 'patch'];

const saApi = axios.create({
  baseURL: API_URL,
  withCredentials: true, // httpOnly cookies отправляются автоматически
  headers: { 'Content-Type': 'application/json' },
});

// CSRF-токен для мутирующих запросов
saApi.interceptors.request.use((config) => {
  if (config.method && CSRF_METHODS.includes(config.method.toLowerCase())) {
    const csrf = getCsrfToken();
    if (csrf) config.headers['X-CSRF-Token'] = csrf;
  }
  return config;
});

saApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem('sa_name');
      window.location.href = '/admin/superadmin/login';
    }
    return Promise.reject(error);
  }
);

export default saApi;
